import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Button } from 'react-bootstrap5';

import ModalWithoutWrapper from 'components/new_ui/Modal/ModalWithoutWrapper';
import VideoPlayer from 'components/Widgets/VideoPlayer';
import ExternalLink from 'components/Widgets/ExternalLink';
import { useContext as useUsersContext } from 'components/Users/Context';
import actions from 'components/Affiliates/Training/Actions';

export default function TrainingStepDocument({ record }) {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();
  const [showPlayer, setShowPlayer] = useState(false);

  const url = record.content_type === 'file' ? record.document_url : record.link;
  const icon = {
    link: 'web-icon',
    video: 'video-icon',
    file: 'article-icon',
  };
  const className = 'w-100 icon-with-text p-3 bg-gray-200 border-0 rounded text-gray-900 text-decoration-none';

  const markAsRead = () => {
    actions.markTrainingStepDocumentAsRead(
      record.id,
      () => actionsUsers.load(dispatchUsers),
    );
  };

  const content = (
    <>
      <div className="d-flex p-3 bg-white rounded-circle">
        <i className={`${icon[record.content_type]} small-icon bg-secondary`} />
      </div>

      <div className="text-content">
        {record.title}
      </div>
    </>
  );

  if (record.content_type === 'file') {
    return (
      <Col className="mb-3">
        <ExternalLink
          href={url}
          variant={null}
          className={className}
          onClick={markAsRead}
        >
          {content}
        </ExternalLink>
      </Col>
    );
  }

  if (record.content_type === 'video') {
    return (
      <>
        <Col className="mb-3">
          <Button
            variant="link"
            className={className}
            onClick={() => {
              markAsRead();
              setShowPlayer(true);
            }}
          >
            {content}
          </Button>
        </Col>

        <ModalWithoutWrapper size="lg" show={showPlayer} onHide={() => setShowPlayer(false)}>
          <VideoPlayer
            url={record.link}
          />
        </ModalWithoutWrapper>
      </>
    );
  }

  return (
    <Col className="mb-3">
      <ExternalLink
        href={url}
        className={className}
        onClick={markAsRead}
      >
        {content}
      </ExternalLink>
    </Col>
  );
}

TrainingStepDocument.propTypes = {
  record: PropTypes.object.isRequired,
};
